// calculate the distance in a list of items relative to a location im meters
// (https://github.com/dcousens/haversine-distance)

import { referenceComparator } from "./Drilldown"

export const calculateDistanceOn = (location, locatedItems) => {
  return locatedItems.map(item => {
    const itemLocation = { lat: item.latitude, lng: item.longitude }
    const distance = itemLocation.lat && itemLocation.lng ? distanceInMetersBetween(location, itemLocation) : null
    return { ...item, distance }
  })
}

export const distanceInMetersBetween = (location1, location2) => {
  const EarthRadius = 6378137
  const distanceLat = radians(location2.lat - location1.lat)
  const distanceLng = radians(location2.lng - location1.lng)

  const f =
    squared(Math.sin(distanceLat / 2.0)) +
    Math.cos(radians(location1.lat)) * Math.cos(radians(location2.lat)) * squared(Math.sin(distanceLng / 2.0))
  const c = 2 * Math.atan2(Math.sqrt(f), Math.sqrt(1 - f))

  return Math.abs(Math.round(EarthRadius * c))
}

export const nearest = (n, properties) => properties.sort(propertyDistanceComparator).slice(0, n)

const propertyDistanceComparator = (a, b) => distanceComparator(a, b) || referenceComparator(a, b)

export const distanceComparator = (item1, item2) => {
  if (item1.distance == null) return 1
  if (item2.distance == null) return -1
  return item1.distance - item2.distance
}

export const formatDistance = distance => {
  if (distance == null) return null
  if (distance < 1000) return `${distance} m`
  const formattedDist = (distance / 1000.0).toFixed(1).toLocaleString("de-DE")
  return `${formattedDist} km`
}

const radians = x => (x * Math.PI) / 180
const squared = x => x * x



// WEBPACK FOOTER //
// ./src/features/common/locationSupport.js